module.exports = __webpack_public_path__ + "static/media/instrotec-ltd.ed10b661.png";